import { render, staticRenderFns } from "./TabResultados.vue?vue&type=template&id=52bd15d1&scoped=true"
import script from "./TabResultados.vue?vue&type=script&lang=js"
export * from "./TabResultados.vue?vue&type=script&lang=js"
import style0 from "./TabResultados.vue?vue&type=style&index=0&id=52bd15d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bd15d1",
  null
  
)

export default component.exports